// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"04a98f17","37":"80fdec4b","160":"6cd5efdb","171":"d61e486d","208":"43904f57","293":"aeeba2c8","429":"27911449","456":"7d4dbe78","507":"2988652e","516":"9fed52fd","519":"a36d34f2","917":"7085f100","923":"9ae36e5b","946":"93cc48a9"}[chunkId] + ".chunk.js";
};